const calcArena = (placement) => {
  const t = placement
    .map((p, i) => [p, i])
    .sort((a, b) => a[0] - b[0])
    .map((t) => t[1]);
  return [t.slice().splice(0, 8), t.slice().splice(8, 15)];
};

export default calcArena;
